import React, { useState } from 'react';

import { Grid } from "@mui/material";
import { BannerGrid, ContatoGrid, Address, OutsideLink } from "./Contato.js";

import { Footer } from '../../components/Footer/Footer.jsx';
import { Header } from '../../components/Header/Header.jsx';
import { Form } from '../../components/Form/Form.jsx';
import { GoogleMap, LoadScript, InfoWindow, MarkerF } from '@react-google-maps/api';


import Circle from '../../assets/cangoo-banner-elemento.png'
import ContatoImg from '../../assets/cangoo-contato-img.png'
import Email from '../../assets/cangoo-contato-icon-email.png'
import Endereco from '../../assets/cangoo-contato-icon-endereco.png'
import Telefone from '../../assets/cangoo-contato-icon-telefone.png'
import Whatsapp from '../../assets/cangoo-contato-icon-wp.png'

import LogoFaceOff from '../../assets/cangoo-fb-on.png'
import LogoFaceOn from '../../assets/cangoo-fb-off.png'

import LogoInstaOff from '../../assets/cangoo-ig-on.png'
import LogoInstaOn from '../../assets/cangoo-ig-off.png'

import LogoLinkedinOff from '../../assets/cangoo-ld-on.png'
import LogoLinkedinOn from '../../assets/cangoo-ld-off.png'


const containerStyle = {
  width: '100%',
  height: '460px',
};

const address = {
  lat: -27.614275287038314,
  lng: -48.59643563338985
};


const apiKey = 'AIzaSyD0yNbu6QkqQSZXgkrthycKFjmvdRf-9jI';

const libraries = ['places'];



export function Contato() {
  const [map, setMap] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const [isFacebookHovered, setIsFacebookHovered] = useState(false);
  const [isInstaHovered, setIsInstaHovered] = useState(false);
  const [isLinkedinHovered, setIsLinkedinHovered] = useState(false);

  const onLoad = React.useCallback((mapInstance) => {
    setMap(mapInstance);
    setIsLoaded(true);
  }, []);

  const onUnmount = React.useCallback(() => {
    setMap(null);
  }, []);

  const handleMouseOverFace = () => {
    setIsFacebookHovered(true);
  };

const handleMouseOutFace = () => {
    setIsFacebookHovered(false);
  };
  

  const handleMouseOverInsta = () => {
    setIsInstaHovered(true);
  };

  const handleMouseOutInsta = () => {
    setIsInstaHovered(false);
  };

  const handleMouseOverLinkedin = () => {
    setIsLinkedinHovered(true);
  };

  const handleMouseOutLinkedin = () => {
    setIsLinkedinHovered(false);
  };


  const handleWhatsappClick = () => {
    window.open('https://wa.me/554833645744', '_blank');
  };


    return (
      <>
      <Header/>

      <BannerGrid container>
        <Grid className='sideA' item xs={12} sm={12} md={12}>
<div className="title">
  <h1>Contato</h1>
  <img src={Circle} alt="" />
</div>
        </Grid>
      </BannerGrid>

<ContatoGrid container>
<Grid className='sideA' item xs={12} sm={12} md={6}>
<img className='informacoes-bg' src={ContatoImg} alt="" />

<div className='informacoes'>
<div className='endereco'>
<img className='icon' src={Endereco} alt="" />
<h1>ENDEREÇO</h1>
</div>
<p>
Rua Antônio Filomeno, 110<br/>
Bairro Bom Abrigo<br/>
Florianópolis - SC<br/>
88085-355
</p>

<h1>ENTRE EM CONTATO</h1>
<ul>
  <li><img className='icon' src={Telefone} alt="" /><OutsideLink href="tel:483364.5744"><span>+55 48 3364.5744</span></OutsideLink></li>
  <li><img className='icon' src={Whatsapp} alt="" /><span onClick={handleWhatsappClick}>+55 48 3364.5744</span></li>
  <li><img className='icon' src={Email} alt="" /> <OutsideLink href="mailto:contato@vaidecangoo.com.br"><span>contato@vaidecangoo.com.br</span></OutsideLink></li>
</ul>

<h1>NOSSAS REDES SOCIAIS</h1>
<div className='redes-sociais'>
<OutsideLink href="https://www.facebook.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverFace} onMouseOut={handleMouseOutFace}>
              <img style={{ width: 30 }} src={isFacebookHovered ? LogoFaceOn : LogoFaceOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.instagram.com/vaidecangoo" target="_blank" onMouseOver={handleMouseOverInsta} onMouseOut={handleMouseOutInsta}>
              <img style={{ width: 30, marginRight:'1.4rem', marginLeft: '1.4rem' }} src={isInstaHovered ? LogoInstaOn : LogoInstaOff} border="0" alt=''/>
            </OutsideLink>
      
            <OutsideLink href="https://www.linkedin.com/company/vaidecangoo" target="_blank" onMouseOver={handleMouseOverLinkedin} onMouseOut={handleMouseOutLinkedin}>
              <img style={{ width: 30 }} src={isLinkedinHovered ? LogoLinkedinOn : LogoLinkedinOff} border="0" alt=''/>
            </OutsideLink>
</div>
</div>
</Grid>

        <Grid className='sideB' item xs={12} sm={12} md={6}>
        <div className="form-text">
<h1>Fale com a gente!</h1>

<p>
Preencha o formulário abaixo para falar com
nossa equipe.
</p>
</div>

<Form className='form-content' pagina={"Contato"} />
        </Grid>

</ContatoGrid>

     
<LoadScript 
  googleMapsApiKey={apiKey} 
  onLoad={onLoad} 
  onUnmount={onUnmount}
  libraries={libraries} 
>
    <GoogleMap mapContainerStyle={containerStyle} center={address} zoom={15}>
      <MarkerF position={address}>
        <InfoWindow position={address}>
          <Address>
            <h1>Cangoo Express</h1>
            <p>Rua Antônio Filomeno, 110<br/> Bairro Bom Abrigo, Florianópolis - SC<br/> 88085-355</p>
          </Address>
        </InfoWindow>
      </MarkerF>
    </GoogleMap>
</LoadScript>


      <Footer/>

      </>
    )
  }